import { render, staticRenderFns } from "./DetailTeleconsulto.vue?vue&type=template&id=2f9bc844&"
import script from "./DetailTeleconsulto.vue?vue&type=script&lang=js&"
export * from "./DetailTeleconsulto.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports